import { history } from '@/redux/lib/configureStore.js';
import { GRAVITY_WEBSITE_HANDOFF_HISTORY_STATE_KEY, GRAVITY_WEBSITE_HANDOFF_QUERY_KEY } from './gravityWebsiteHandoffConstants.js';
import { rememberGravityWebsiteHandoffId } from './gravityWebsiteHandoffMemory.js';
import persistGravityWebsiteHandoff from './persistGravityWebsiteHandoff.js';
import readGravityWebsiteHandoffIdFromSearch from './readGravityWebsiteHandoffIdFromSearch.js';

const consumeGravityWebsiteHandoffIdFromSearch = ({ hash = '', pathname = '/signup', search = '' } = {}) => {
  const handoffId = readGravityWebsiteHandoffIdFromSearch(search);
  if (!handoffId) {
    return '';
  }

  persistGravityWebsiteHandoff(handoffId);
  rememberGravityWebsiteHandoffId(handoffId);

  const searchParams = new URLSearchParams(search);
  searchParams.delete(GRAVITY_WEBSITE_HANDOFF_QUERY_KEY);
  const nextSearch = searchParams.toString();
  const nextUrl = `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash}`;

  history.replace(nextUrl, {
    ...(history.location?.state || {}),
    [GRAVITY_WEBSITE_HANDOFF_HISTORY_STATE_KEY]: handoffId
  });
  return handoffId;
};

export default consumeGravityWebsiteHandoffIdFromSearch;
